<ul
  class="account-menu"
  [ngStyle]="menuStyles"
  [mmTestId]="'ALL_PAGES.ACCOUNT_DROPDOWN'"
>
  <div data-hj-suppress>
    <ng-container *ngIf="isMobile && userData !== null">
      <ng-container *ngTemplateOutlet="accountMenuHeader"></ng-container>
    </ng-container>
    <ng-container *ngFor="let item of accountMenu">
      <ng-container *ngTemplateOutlet="dropDownItem; context: { $implicit: item }"></ng-container>
    </ng-container>
  </div>
  <li
    *ngIf="!isMobile; else logoutButton"
    class="account-menu__item"
  >
    <div class="account-menu__link-wrapper">
      <span
        class="account-menu__logout-link"
        (click)="logOut()"
        [mmTestTarget]="'account-dropdown-logout-button'">
        {{ 'CORE.ALL_PAGES.USER_BOX.LOG_OUT.LABEL' | translate }}
      </span>
    </div>
  </li>
</ul>

<ng-template #dropDownItem let-menuItem>
  <li>
    <a
      class="account-menu__link"
      [ngClass]="{ 'account-menu__link-mobile': isMobile }"
      [routerLink]="menuItem.link"
      (click)="onMenuItemClick(menuItem.link)"
      [mmTestTarget]="'account-dropdown-close-button'">
      <div class="account-menu__link-wrapper">
        {{ menuItem.title | translate }}
      </div>
    </a>
  </li>
</ng-template>

<ng-template #accountMenuHeader>
  <li class="account-menu__link-mobile account-menu__user-data">
    <img [src]="avatarIcon" class="account-menu__avatar"/>
    <div class="account-menu__user-info">
        <span class="account-menu__name" data-hj-suppres>{{userData.firstName}} {{userData.lastName}}</span>
        <span class="account-menu__organization" data-hj-suppres>{{userData.organizationName}}</span>
    </div>
    <span
    class="account-menu__close-button"
    (click)="closeMenu()"
    [mmTestTarget]="'account-dropdown-close-button'"
  >
    <mm-icon name="close"></mm-icon>
  </span>
  </li>

</ng-template>

<ng-template #logoutButton>
  <span
    class="account-menu__logout"
    (click)="logOut()"
    [mmTestTarget]="'account-dropdown-logout-button'">
    {{ 'CORE.ALL_PAGES.USER_BOX.LOG_OUT.LABEL' | translate }}
</span>
</ng-template>

